import React from "react";
import { NavLink } from "react-router-dom";

import UnileverMockup from "../assets/unilever-mockup.png";
import TMWMockup from "../assets/tmw-mockup.png";
import WebPort from "../assets/portfolio.png";

import "./WebDesignContentStyles.css";

const WebDesignContent = () => {
  return (
    <div>
      <div className="container-col-2">
        <div className="left-container">
          <img className="image-size" src={WebPort} />
        </div>
        <div className="right-container">
          <h1>Sir Dhan A. Mota Web Portfolio</h1>
          <p>
            Sir Dhan A. Mota's website portfolio demonstrates his extensive
            skillset in various programming languages, including Visual Basic,
            C#, HTML, CSS, JavaScript, Python, and SQL. His proficiency in these
            languages enables him to create robust and interactive web
            applications and desktop applications that meet the needs of his
            clients.
          </p>
          <a
            href="https://www.figma.com/proto/UfSXk7xHIo0fZ9Rrq8kUPW/Portfolio-Wireframe?node-id=1-2&starting-point-node-id=1%3A2"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            View Project
          </a>
        </div>
        <div className="left-container">
          <img className="image-size" src={TMWMockup} />
        </div>
        <div className="right-container">
          <h1>Telos Media Works Proposed Website Mockup</h1>
          <p>
            Telos Media Works aim is to provide future-proof solutions with
            innovation and modernization using reliable and latest technologies
            that allows to achieve success. As a designer, I collaborated with
            Telos Media Works team to design a mockup website that may be used
            as an idea in developing the actual website.
          </p>
          <NavLink
            to="https://www.figma.com/proto/sihnwKog86Gk6h9OkwpB4E/Telos-Media-Works?node-id=0-3&starting-point-node-id=0%3A3"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={UnileverMockup} />
        </div>
        <div className="right-container">
          <h1>Unilever | TVCXpress Manila Archive Mockup</h1>
          <p>
            TVCXpress Media Archiving System is the first comprehensive and
            AI-driven Archiving Platform. I designed a mockup design for
            Unilever Archiving System for the purpose of them availing the said
            system for their convenience with added value functions for
            future-proof solutions.
          </p>
          <NavLink
            to="https://www.figma.com/proto/Gw4hzAagJWSe3j5So2K0HH/Unilever-Archive?node-id=1-2&starting-point-node-id=1%3A2"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            View Project
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default WebDesignContent;
